export default __webpack_public_path__ + "static/media/kalechips@3x.7f931f4a.jpg";